import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, CircularProgress } from '@mui/material';

export default function ConfirmDeleteModal({ open, onClose, onConfirm, itemName = "item", isLoading = false, title = "Confirm Deletion", bodyText, confirmText = "Ok", confirmColor = "error" }) {
    return (
        <Dialog
            open={open}
            onClose={!isLoading ? onClose : undefined}
            PaperProps={{ sx: { borderRadius: 3, padding: 1 } }}
        >
            <DialogTitle fontWeight="bold">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {bodyText || `Are you sure you want to delete this ${itemName}?`}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: '0 24px 16px 24px' }}>
                <Button onClick={onClose} color="primary" variant="outlined" sx={{ borderRadius: 2 }} disabled={isLoading}>
                    Cancel
                </Button>
                <Button 
                    onClick={onConfirm} 
                    color={confirmColor} 
                    variant="contained" 
                    sx={{ borderRadius: 2 }}
                    disabled={isLoading}
                    startIcon={isLoading && <CircularProgress size={16} color="inherit" />}
                >
                    {isLoading ? 'Processing...' : confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
